module.exports = __webpack_public_path__ + "fce58439592bd8558d1a97509616e90e.fbx";